import { merge } from 'global/lib/lodash';
import { SET_DATA, SET_HARD_DATA } from '../actions/types';
import initialState from '../initialState';

export default function (state = initialState.data, action) {
  switch (action.type) {
    case SET_DATA:
      return merge({}, state, action.data);
    case SET_HARD_DATA:
      return action.data;
    default:
      return state;
  }
}
